var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_120_381",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_120_381",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/ElEQVR4nO3dzWoTURyG8RcXVrC9gqIuehEF3XanK1fvStz2CrwOQQQXXbRegYhIoeBC9DIE3ekN1N2RA0cImOZjMs68kzw/+EM4IZPJPAxkCEwkAAAAAAAAAACAf9ySdNKmPsaI9iVdSSptrtoaRnBX0qeZGH/ni6QDimTEKETJi1GIkhejECUvRiFKXoxClP7tS/p8w4H+teJaadvgK/F/PDMuJT2fs/5M0nvOlOFj3JHkOc/VtdtEGT6GFgSpiDJwjGVBKqIMGGOVIBVRBoqxapCKKAPEWCdIRZQerjM+LoixbhC1bdVtcp2ywFnHGF2CLItyvuS1O+FnxxhdgyyKUq/yd95lxxibBLkpyocVX7vVDiW9k/RD0qs1YmwaRO29Xkr63vah7gs24A2DoGcmSBYTJIsJksUEyWKCZDFBspggWUyQLCZIFhMkiwmSxQTJYoJkMUGymCBZTJAsJkgWEySLCZLFBMligmQxQbKYIFlMkCwmSBYTJIsJksUEyWKCZDFBspggWUyQLE/nBKlrGMl9Sb9nYlxLukeNcT2R9LXNY2IAAAAAAAAAAHbDkaRTSS8mPqfts0zao/ajUdmSuZb0UBP2NuAglp7nQhP2JuAAlp7ntSbsqN2CtWzJfJP0QBNX7417PPN/tVOdY0l7Yx9MAAAAAFDP/gCfaba+Jvb1SAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ca1861f8d5a9bebd6dfaf3c132029880.svg";
export { ForwardRef as ReactComponent };